<template>
  <el-select v-model="invoiceTypeValue" @change="invoiceTypeChange" :placeholder="placeholder" v-bind="$attrs" :style="{ width: width }" :clearable="clearable">
    <el-option v-for="item in invoiceTypeData" :key="item.value" :label="item.name" :value="item.value"></el-option>
  </el-select>
</template>

<script>
import invoiceTypeMixins from '@/mixins/invoice_type_mixins.js';

export default {
  name: 'invoiceTypeSelect',
  mixins: [invoiceTypeMixins],
  components: {},
  props: {
    // 初始值 [invoiceType, invoiceClass], 或者 invoiceType_invoiceClass,非必填
    value: [String, Array],
    placeholder: {
      type: String,
      default: '',
    },
    width: { type: String },
    // 是否默认选中默认值
    defaultValue: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // 开票类型数据 invoiceTypeData迁移到mixins
      // invoiceTypeData: [],
      invoiceTypeValue: '',
      hasSetData: false,
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      handler(val, oldVal) {
        if (val && val.length) {
          const arr = Array.isArray(val) ? val : val.split('_');
          if (arr[0] && arr[1]) {
            // 重复数据不操作
            if (oldVal && arr[0] === oldVal[0] && arr[1] === oldVal[1]) {
              return;
            }
          }
          this.setData(...arr);
        } else {
          this.setData('');
        }
      },
    },
  },
  filters: {},
  directives: {},
  methods: {
    invoiceTypeChange(e) {
      this.emitValue(e, 'change');
    },
    emitValue(value, eventName) {
      const val = value || '';
      this.$emit('input', val);
      this.$emit(eventName, val);
    },
    // 发票类型默认为 增值税专用发票（纸质量）
    initDefaultValue() {
      // 当外部设置了值，这里就不需要触发默认值设置了
      if (this.hasSetData) {
        return;
      }
      const invoiceType = this.dicMap.invoice_type;
      const invoiceClass = this.dicMap.invoice_class;

      this.invoiceTypeValue = [invoiceType.special, invoiceClass.paper].join('_');

      const initValue = this.initValue;
      if (initValue && initValue.length && initValue[0] && initValue[1]) {
        return;
      }
      this.emitValue(this.invoiceTypeValue, 'init');
    },
    // 设置select选项值
    setData(invoiceType, invoiceClass) {
      if (invoiceType !== undefined && invoiceClass !== undefined) {
        this.hasSetData = true;
        if (invoiceType && invoiceClass) {
          const ret = [invoiceType, invoiceClass].join('_');
          // 设置值与原有值相同，不操作
          if (ret === this.invoiceTypeValue) {
            return;
          }
          this.invoiceTypeValue = ret;
          return;
        }
      }
      this.invoiceTypeValue = '';
    },
  },
  created() {},
  mounted() {
    if (this.defaultValue) {
      this.initDefaultValue();
    }
    this.emitValue(this.invoiceTypeValue, 'init');
  },
};
</script>

<style></style>
